/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import DifferenceComponent from "../../../admin/test-dashboard/difference/difference";
import Button from "../../button";

// Interface for component Props
interface AdminPopupComponentProps {
  open: boolean;
  close: () => void;
  t?: any;
  questionType?: string;
  onDelete?: () => void;
  buttonName: string;
  cancleButtonName: any;
  heading?: string;
  title?: string;
}

// Interface for component State
interface AdminPopupComponentState {}

/**
 * Admin popup component.
 *
 * @namespace AdminPopupComponent
 */

class AdminPopupComponent extends Component<
  AdminPopupComponentProps,
  AdminPopupComponentState
> {
  constructor(props: AdminPopupComponentProps) {
    super(props);
  }
  handleOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.props.close();
    }
  };

  render() {
    const { open, questionType, buttonName, cancleButtonName } = this.props;
    return (
      <div>
        <Modal
          open={open}
          onClose={buttonName!=="sessionExpired"?this.props.close:()=>{}}
          center
          classNames={{
            overlay: "custom-overlay",
            modal: "modal-container admin-modal",
            closeButton: "hide",
          }}
        >
          <div className="popup-wrapper">
            <div className="popup-header-container">
              {buttonName!=="sessionExpired"&& (<div
                tabIndex={0}
                role="button"
                className="popup-close-icon"
                onClick={this.props.close}
                onKeyPress={this.handleOnKeyPress}
              >
              <span className="icon close-icon"></span>
              </div>)}
              <div className="popup-header">
                <div className="popup-label">{this.props.heading}</div>
              </div>
            </div>
            <div className="popup-inner-wrapper">
              <div className="popup-detail">{this.props.title}</div>
            </div>
            <div className="popup-button-wrapper">
              {buttonName!=="sessionExpired" &&(<div className="btn-wrapper">
                <Button
                  name={cancleButtonName}
                  className="app-btn border-btn"
                  onButtonClick={this.props.close}
                />
              </div>)}

              <div className="btn-wrapper">
                <Button
                  name={buttonName!=="sessionExpired"?buttonName : "Login"}
                  className="app-btn "
                  onButtonClick={() => {
                    if (this.props.onDelete) {
                      this.props.onDelete();
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AdminPopupComponent;
